// A conversation turn as text an agent reading a session can quote: prose as
// written, tool calls with their arguments, tool results with their output.
// For a finding about what an agent did, the calls and results are the
// evidence; a reader that keeps only prose sees a working stretch of a
// session as empty turns. Shared by the Triage and Investigate kits.
const str = (v) => (v == null ? "" : String(v));

// A block as evidence. Tool calls and their results are rendered in full
// shape, because the difference between "ran a command" and "ran it and got
// nothing back" is the difference between two verdicts.
export function blockText(block) {
    if (!block) return "";
    if (block.type === "text") return str(block.text);
    if (block.type === "tool_use") {
        const input = block.input === undefined || block.input === null
            ? "(arguments not captured)"
            : JSON.stringify(block.input);
        return `[tool_use ${block.name || "?"}] ${input}`;
    }
    if (block.type === "tool_result") {
        const body = typeof block.content === "string" ? block.content : JSON.stringify(block.content ?? null);
        return `[tool_result ${block.tool_name || "?"}${block.isError ? " ERROR" : ""}] ${body ?? "(result not captured)"}`;
    }
    return "";
}
export const turnText = (turn) => (turn?.blocks || []).map(blockText).filter(Boolean).join("\n");
